import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { APIService, KPI } from '../api';

@Injectable()
export class AuditExpertService {
  constructor(private api: APIService) {}

  public getAssetKPIExpert(assetId: number): Observable<KPI.Default[]> {
    return this.api.audit_asset_kpi_expert(assetId);
  }
}
